module.exports = __webpack_public_path__ + "static/media/014-man-3.f8f72c4c.svg";